import { render, staticRenderFns } from "./MobFundHoldingChart.vue?vue&type=template&id=2f7e895f&scoped=true"
import script from "./MobFundHoldingChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFundHoldingChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFundHoldingChart.vue?vue&type=style&index=0&id=2f7e895f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e895f",
  null
  
)

export default component.exports